import angular, { IRootScopeService, IScope, cookies, idle } from 'angular';
import { IFlowinglyWindow } from './interfaces/flowingly.window';
import { IStateService } from 'angular-ui-router';
import { SharedAngular } from './@types/sharedAngular';
import {
  labelType,
  linkType,
  linkWithActionType,
  linkWithCountType,
  linkWithActionCountType
} from './sidemenu/sidemenu.constants';
import { FlowinglyPermissions } from '@Shared.Angular/flowingly.services/flowingly.constants';
import { IFlowModelPublishedMessage } from '@Shared.Angular/@types/pubSub';
import { STATE_MAPPINGS } from '@Shared.Angular/@types/stateMappings';
import IUserDetail from '@Shared.Angular/@types/core/contracts/queryModel/user/userDetail';

declare const window: IFlowinglyWindow;

runnerController.$inject = [
  '$rootScope',
  '$state',
  '$location',
  'sideMenuService',
  'authService',
  'flowListManager',
  'pubsubService',
  'userNotificationsApiService',
  'sessionService',
  'browserUtilsService',
  'Idle',
  '$cookies',
  'exagoApiService',
  'exagoJsApiResource',
  'tokenService',
  'permissionsService',
  'APP_CONFIG',
  'gtmService',
  'scriptService',
  'appInsightsService',
  '$scope',
  'webPushService',
  'flowTodoService',
  '$window',
  'governanceApiService'
];

function runnerController(
  $rootScope: IRootScopeService,
  $state: IStateService,
  $location: angular.ILocationService,
  sideMenuService: SideMenuService,
  authService: AuthService,
  flowListManager: FlowListManager,
  pubsubService: SharedAngular.PubSubService,
  userNotificationsApiService: SharedAngular.UserNotificationsApiService,
  sessionService: SharedAngular.SessionService,
  browserUtilsService: SharedAngular.BrowserUtilsService,
  Idle: idle.IIdleService,
  $cookies: cookies.ICookiesService,
  exagoApiService: ExagoApiService,
  exagoJsApiResource: SharedAngular.ExagoJsApiResource,
  tokenService: SharedAngular.TokenService,
  permissionsService: SharedAngular.PermissionsService,
  APP_CONFIG: SharedAngular.APP_CONFIG,
  gtmService: SharedAngular.GTMService,
  scriptService: SharedAngular.ScriptService,
  appInsightsService: SharedAngular.AppInsightsService,
  $scope: IScope,
  webPushService: WebPushService,
  flowTodoService: FlowTodoService,
  $window: angular.IWindowService,
  governanceApiService: GovernanceApiService
) {
  const rctrl = this;
  rctrl.logout = () => authService.logout(true);
  rctrl.toggleShowSmartSearch = () => {
    rctrl.showSmartSearch =
      APP_CONFIG.enableSmartSearch && !rctrl.showSmartSearch;
  };
  rctrl.pageHeader = angular.copy($rootScope.pageHeader);
  rctrl.authenticated = sessionService.isAuthenticated();
  rctrl.user = sessionService.getUser();
  rctrl.showSmartSearch = false;
  rctrl.isTestFlow = $location.search().isTestFlow === 'true';

  if (rctrl.user && rctrl.user.id) {
    authService.getUser().then((user) => {
      if (user && user.id) {
        rctrl.user = user;
        $scope.$applyAsync();
      }
    });
  }

  $rootScope.$on(
    '$stateChangeStart',
    function (e, toState, toParams, fromState, fromParams, options) {
      rctrl.pageHeader = angular.copy($rootScope.pageHeader);
      let backFromState = null;
      if ($window.event?.type !== 'popstate' || toParams.backFromState) {
        return;
      }
      if (
        toState.name === STATE_MAPPINGS.flowstodo &&
        fromState.name === STATE_MAPPINGS.flow
      ) {
        backFromState = STATE_MAPPINGS.flow;
      } else if (
        toState.name === STATE_MAPPINGS.flowsactive &&
        fromState.name === STATE_MAPPINGS.flow
      ) {
        backFromState = STATE_MAPPINGS.flow;
      }

      if (backFromState) {
        e.preventDefault();
        $state.go(
          toState.name,
          Object.assign({}, toParams, { backFromState: backFromState }),
          { location: 'replace' }
        );
      }
    }
  );

  $rootScope.$on('$stateChangeSuccess', function (event, toState, toParams) {
    //for some reason $stateParams is empty when we need to use it in onWorkflowPublishedReceived,
    //therefore save the category here;
    rctrl.categoryId = toParams.categoryId;
  });

  // subscribe signalR events. These are used to respond to ANOTHER user completing an action
  // if the currently logged in user completes a step it will be handled by the service
  const runnerControllerKey = 'runner.controller';

  pubsubService.subscribe(
    'SIGNALR_WORKFLOW_PUBLISHED',
    onWorkflowPublishedReceived,
    runnerControllerKey
  );
  pubsubService.subscribe(
    'SIGNALR_WORKFLOW_UNPUBLISHED',
    onWorkflowUnPublishedReceived,
    runnerControllerKey
  );
  pubsubService.subscribe(
    'SIGNALR_USER_PROFILE_UPDATED',
    onUserProfileUpdatedReceived,
    runnerControllerKey
  );
  pubsubService.subscribe(
    'CLIENT_USER_PROFILE_UPDATED',
    (event, userData) => {
      if (userData && userData.id) {
        rctrl.user = userData;
        flowListManager.clearReportModelList();
        $scope.$applyAsync();
      }
    },
    runnerControllerKey
  );
  pubsubService.subscribe(
    'SIGNALR_RUNNER_USER_TEAM_UPDATED',
    invalidateReportFlowModelsCache,
    runnerControllerKey
  );

  $scope.$on('$destroy', () => {
    pubsubService.unsubscribeAll(runnerControllerKey);
  });

  // Handle timeout event
  $rootScope.$on('IdleStart', function () {
    if (tokenService.isAllApplicationIdle()) {
      console.log(
        `IdleStart all idle: ${localStorage.getItem(
          'ngIdle.expiry'
        )}, AllApplicationIdle: ${$cookies.get('ngIdle.expiry')}`
      );

      const loginRouteName = STATE_MAPPINGS.login;
      if ($state.current.name !== loginRouteName) {
        tokenService.setInLogoutProcess(true);
        authService.logout();
      }
    } else {
      console.log(
        `IdleStart: ${localStorage.getItem(
          'ngIdle.expiry'
        )}, AllApplicationIdle: ${$cookies.get('ngIdle.expiry')}`
      );
      tokenService.manualIdleCheck();
    }
  });

  $rootScope.$on('IdleInterrupt', function () {
    tokenService.setIdleExpiry();
  });

  initialise();

  function initialise() {
    if (
      !browserUtilsService.isMobileDevice() &&
      APP_CONFIG.enableExago &&
      permissionsService.currentUserHasPermission(
        FlowinglyPermissions.REPORT_BI_ACCESS
      )
    ) {
      const script =
        APP_CONFIG.exagoBaseUrl + 'WrScriptResource.axd?s=ExagoApi';
      scriptService
        .loadScript(script, 'text/javascript', 'utf-8')
        .then(loadExago);
    }

    createMenu();

    //collapses all the flows
    rctrl.expand = false;

    if (!browserUtilsService.isApp()) {
      Idle.watch();
      tokenService.setIdleExpiry();
    }

    console.log(
      `Idle watch: ${localStorage.getItem(
        'ngIdle.expiry'
      )}, AllApplicationIdle: ${localStorage.getItem(
        'ngIdle.expiry'
      )}, AllApplicationIdle.Mobile: ${localStorage.getItem(
        'ngIdle.expiry.mobile'
      )}`
    );

    if (APP_CONFIG.googleTagManagerId) {
      gtmService.loadGTM(APP_CONFIG.googleTagManagerId);
    }

    flowTodoService.getRefreshedFlows();
    webPushService.trySetupWebPush($scope);
  }

  function loadExago() {
    exagoApiService
      .getSessionKey()
      .then((data: { appUrl: string; apiKey: string }) => {
        if (!data) {
          console.warn("Can't create Exago API instance");
          return;
        }

        exagoJsApiResource.CreateInstance(data.appUrl, data.apiKey);
      });
  }

  function invalidateReportFlowModelsCache() {
    if (sessionService.isLoggedIn()) {
      flowListManager.clearReportModelList();
    }
  }

  function onWorkflowPublishedReceived(
    event,
    message: IFlowModelPublishedMessage
  ) {
    if (!sessionService.isLoggedIn()) {
      return;
    }

    flowListManager.clearReportModelList();
  }

  function onWorkflowUnPublishedReceived(event, message) {
    ///
    /// This method handles a workflow being unpublished.
    /// It removes it from all lists.

    if (!sessionService.isLoggedIn()) {
      return;
    }

    flowListManager.clearReportModelList();
  }

  function onUserProfileUpdatedReceived(event, message) {
    if (!sessionService.isLoggedIn()) {
      return;
    }

    let user = sessionService.getUser();
    sessionService.getUserDetails(user.email).then((resp) => {
      if (resp != undefined) {
        const userDetails = resp.data as IUserDetail;
        user = sessionService.formatUserForLocalStorage(userDetails);
        sessionService.clearUser();
        sessionService.setUser(user);
        pubsubService.publish(
          'CLIENT_USER_PROFILE_UPDATED',
          sessionService.getUser()
        );
      }
    });
  }

  function getNotificationCount() {
    return userNotificationsApiService.notificationCount;
  }

  function showFlowsTodoCount() {
    return true;
  }

  function showNotificationCount() {
    return userNotificationsApiService.notificationCount > 0;
  }

  function createMenu() {
    const isMobileDevice = browserUtilsService.isMobileDevice();

    //Clearing existing menu whenever fresh createMenu is called. see FLOW-1194
    sideMenuService.clearMenu();

    if (APP_CONFIG.allowWorkflow) {
      sideMenuService.addmenuItem({
        name: 'Start',
        hovertext: 'Start Flows',
        mobilename: 'Start Flows',
        type: linkType,
        icon: 'fa-light fa-play',
        target: STATE_MAPPINGS.flowsactive,
        permissions: [FlowinglyPermissions.FLOW_START]
      });
    }

    if (APP_CONFIG.allowWorkflow) {
      sideMenuService.addmenuItem({
        name: 'To Do',
        hovertext: 'To Do',
        mobilename: 'To Do',
        type: linkWithCountType,
        icon: 'fa-light fa-list',
        target: STATE_MAPPINGS.flowstodo,
        count: () => flowTodoService.getFlowCount(),
        show: showFlowsTodoCount,
        permissions: [FlowinglyPermissions.TODO_ACCESS]
      });
    }

    if (APP_CONFIG.allowWorkflow) {
      sideMenuService.addmenuItem({
        name: 'Flows',
        hovertext: "Flows I'm In",
        mobilename: "Flows I'm In",
        type: linkType,
        icon: 'fa-light fa-merge',
        target: STATE_MAPPINGS.flowsin
      });
    }

    if (APP_CONFIG.enableProcedures) {
      sideMenuService.addmenuItem({
        name: 'SOPs',
        mobilename: 'SOPs',
        hovertext: 'Standard Operating Procedures',
        type: linkType,
        icon: 'fa-light fa-file-magnifying-glass',
        target: STATE_MAPPINGS.procedures
      });
    }

    if (APP_CONFIG.allowProcessMap) {
      sideMenuService.addmenuItem({
        name: 'Maps',
        mobilename: 'Maps',
        hovertext: 'Process Maps',
        type: linkType,
        icon: 'fa-light fa-file-alt',
        target: STATE_MAPPINGS.processmapsv2
      });
    }

    if (!isMobileDevice) {
      if (
        APP_CONFIG.enableGovernance &&
        permissionsService.currentUserHasPermission(
          FlowinglyPermissions.GOVERNANCE_ACCESS
        )
      ) {
        let displayNotificationBadge = null;
        governanceApiService
          .getGovernanceHasContent()
          .then((governanceHasContent) => {
            displayNotificationBadge = governanceHasContent ? '!' : null;
          });
        const governanceMenuItem = {
          name: 'Governance',
          hovertext: 'Governance',
          icon: 'fa-light fa-building-columns',
          target: STATE_MAPPINGS.governance,
          show: () => true,
          type: linkWithCountType,
          permissions: [FlowinglyPermissions.GOVERNANCE_ACCESS],
          count: () => displayNotificationBadge
        };

        sideMenuService.addmenuItem(governanceMenuItem);
      }

      sideMenuService.addmenuItem({
        name: 'Reports',
        hovertext: 'Reports',
        type: linkType,
        icon: 'fa-light fa-table',
        target: STATE_MAPPINGS.reports,
        permissions: [FlowinglyPermissions.REPORT_ACCESS]
      });

      if (APP_CONFIG.allowWorkflow && APP_CONFIG.enableExago) {
        sideMenuService.addmenuItem({
          name: 'Dashboard',
          hovertext: 'Process Dashboard',
          type: linkType,
          icon: 'fa-light fa-chart-pie',
          target: STATE_MAPPINGS.exagoSingle,
          permissions: [FlowinglyPermissions.REPORT_BI_ACCESS]
        });

        if (APP_CONFIG.allowWorkflow) {
          sideMenuService.addmenuItem({
            name: 'Analytics',
            hovertext: 'Process Analytics',
            type: linkType,
            icon: 'fa-light fa-chart-bar',
            target: STATE_MAPPINGS.exago,
            permissions: [FlowinglyPermissions.REPORT_BI_ACCESS]
          });
        }
      }

      if (APP_CONFIG.enableTemplateLibrary && !isMobileDevice) {
        sideMenuService.addmenuItem({
          name: 'Templates',
          hovertext: 'Template Library',
          mobilename: 'Template Library',
          type: linkWithActionCountType,
          icon: 'fa-light fa-shapes',
          target: STATE_MAPPINGS.templatesLibrary,
          count: () => '!',
          show: () => true,
          action: () => {
            $state.go(STATE_MAPPINGS.templatesLibrary);
            appInsightsService.trackPageView('template-library', {
              from: 'sidemenu'
            });
          }
        });
      }

      sideMenuService.addmenuItem({
        name: 'Library',
        hovertext: 'Library',
        type: linkType,
        icon: 'fa-light fa-cubes',
        target: APP_CONFIG.allowWorkflow
          ? STATE_MAPPINGS.libraryworkflows
          : APP_CONFIG.allowProcessMap
            ? STATE_MAPPINGS.libraryprocessmaps
            : STATE_MAPPINGS.libraryprocedures,
        permissions: [FlowinglyPermissions.LIBRARY_ACCESS]
      });

      let targetState = null;

      if (
        permissionsService.currentUserHasPermission(
          FlowinglyPermissions.SETUP_USER_ACCESS
        )
      ) {
        targetState = STATE_MAPPINGS.setupusers;
      } else if (
        permissionsService.currentUserHasPermission(
          FlowinglyPermissions.SETUP_DATABASE_ACCESS
        )
      ) {
        targetState = STATE_MAPPINGS.setupdatabases;
      } else if (
        permissionsService.currentUserHasPermission(
          FlowinglyPermissions.SETUP_TEAM_ACCESS
        )
      ) {
        targetState = STATE_MAPPINGS.setupteams;
      } else if (
        permissionsService.currentUserHasPermission(
          FlowinglyPermissions.SETUP_CATEGORY_ACCESS
        )
      ) {
        targetState = STATE_MAPPINGS.setupcategories;
      } else if (
        permissionsService.currentUserHasPermission(
          FlowinglyPermissions.SETUP_TAG_ACCESS
        )
      ) {
        targetState = STATE_MAPPINGS.setuptaggroups;
      } else if (
        permissionsService.currentUserHasPermission(
          FlowinglyPermissions.SETUP_ROLE_ACCESS
        )
      ) {
        targetState = STATE_MAPPINGS.setuproles;
      }

      if (targetState !== null) {
        sideMenuService.addmenuItem({
          name: 'Setup',
          hovertext: 'Setup',
          type: linkType,
          icon: 'fa-light fa-gear',
          target: targetState
        });
      }
    }

    if (isMobileDevice) {
      userNotificationsApiService.getNotificationCount().then(() => {
        sideMenuService.addmenuItem({
          name: 'My Account',
          type: labelType,
          icon: ''
        });
        sideMenuService.addmenuItem({
          name: 'Notifications',
          type: linkWithCountType,
          icon: 'fa-light fa-bell',
          target: STATE_MAPPINGS.notifications,
          count: getNotificationCount,
          show: showNotificationCount
        });
        if (
          APP_CONFIG.enableWebPushNotificationsMobile &&
          browserUtilsService.isMobileWebApp()
        ) {
          sideMenuService.addmenuItem({
            name: 'Settings',
            hovertext: 'Settings',
            mobilename: 'Settings',
            type: linkType,
            icon: 'fa-light fa-gear',
            target: STATE_MAPPINGS.settings
          });
        }
        const user = sessionService.getUser();
        sideMenuService.addmenuItem({
          name: `Sign out ${user.fullName}`,
          type: linkWithActionType,
          icon: 'fa-light fa-sign-out-alt',
          action: () => {
            webPushService
              .removeUsersLocalSubscription()
              .finally(() => authService.logout(true));
          }
        });
      });
    }
  }
}

angular
  .module('flowingly.runner')
  .controller('runnerController', runnerController);
